<template>
  <div :id="id" :style="styles">
  </div>
</template>
<script>
  import particlesJS from 'particles.js'
  export default {
    name: 'Particles',
    props: ['config', 'styles'],
    computed: {
      id () {
        return 'particles-' + this._uid
      }
    },
    mounted () {
      window.particlesJS(this.id, this.config)
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// Particles.vue?744a7d42